<app-nav
    [titulo]="cobertura ? 'Editar cobertura: ' + cobertura.nombre : 'Nueva cobertura'"
    [descripcion]="cobertura ? 'Aquí podrá modificar los datos de la cobertura.' : 'Por favor complete todos los datos de la nueva cobertura.'">
    <div class="edit-cobertura basic-avm-editor">
        <div class="form-stepper">
            <form [formGroup]="form" class="form-step">

                <h3 class="form-step-title">{{ cobertura ? 'Editar cobertura' : 'Nueva cobertura' }}</h3>
                <span class="form-step-description">
                    {{ cobertura ? 'Modificá los datos y guardá los cambios.' : 'Completá los datos de la nueva cobertura.' }}
                </span>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Nombre del servicio</mat-label>
                        <input matInput formControlName="nombre" placeholder="Ej: Luz, Agua, Gas, ABL">
                        <mat-error *ngIf="form.controls['nombre'].hasError('required')">El nombre es requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Porcentaje sobre alquiler</mat-label>
                        <input matInput formControlName="porcentaje" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;%</span>
                        <mat-error *ngIf="form.controls['porcentaje'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Tope mínimo (ARS)</mat-label>
                        <input matInput formControlName="topeMinimo" type="number" style="text-align: right;">
                        <mat-error *ngIf="form.controls['topeMinimo'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Tope máximo (ARS)</mat-label>
                        <input matInput formControlName="topeMaximo" type="number" style="text-align: right;">
                        <mat-error *ngIf="form.controls['topeMaximo'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-radio-line">
                    <span class="radio-line-label">Tipo de producto</span>
                    <div class="radios">
                        <mat-radio-group formControlName="tipoProducto">
                            <mat-radio-button value="VIVIENDA">Vivienda</mat-radio-button>
                            <mat-radio-button value="COMERCIAL">Comercial</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Zona (dejar vacío para Default)</mat-label>
                    <mat-select formControlName="idZona">
                        <mat-option [value]="null">Default (todas las zonas)</mat-option>
                        <mat-option *ngFor="let zona of zonas" [value]="zona.id">
                            {{ zona.nombre }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Las coberturas Default aplican a todas las zonas que no tengan override específico.</mat-hint>
                </mat-form-field>

                <div class="form-radio-line">
                    <span class="radio-line-label">Estado</span>
                    <div class="radios">
                        <mat-radio-group formControlName="activo">
                            <mat-radio-button [value]="true">Activo</mat-radio-button>
                            <mat-radio-button [value]="false">Inactivo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ cobertura ? 'Guardar cambios' : 'Crear cobertura' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</app-nav>
